import { successRes, errorRes } from "../../utils.js";

export const handleInstallApp = async (
  { userId, hash, shareApp, appName, authorName, fileSize, iconUrl },
  self
) => {
  const fs = self.state.fileSystem;
  const raw = fs.getFile(hash).getData();
  fs.installNewApp(appName, raw, iconUrl);
  if (shareApp) {
    try {
      const response = await fetch(self.props.host + "/createApp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          appName,
          authorName,
          authorId: userId,
          size: fileSize,
          iconUrl,
          raw,
        }),
      });
      if (response.status !== 200) {
        return errorRes(
          "Looks like there was a problem. Status Code: " + response.status
        );
      }
      const res = await response.text();
      return successRes(res);
    } catch (err) {
      return errorRes("Fetch Error", err);
    }
  }
  return successRes();
};
